var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWifiShowApn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, " icon_wifi_showAPN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-icon_wifi_showAPN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(11.000000, 5.000000)",
    fill: "#005082"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1.5 C0,0.675 0.675,0 1.5,0 C2.325,0 3,0.675 3,1.5 C3,2.325 2.325,3 1.5,3 C0.675,3 0,2.325 0,1.5 Z",
    id: "Path-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.5 C0,5.675 0.675,5 1.5,5 C2.325,5 3,5.675 3,6.5 C3,7.325 2.325,8 1.5,8 C0.675,8 0,7.325 0,6.5 Z",
    id: "Path-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.5 C0,10.675 0.675,10 1.5,10 C2.325,10 3,10.675 3,11.5 C3,12.325 2.325,13 1.5,13 C0.675,13 0,12.325 0,11.5 Z",
    id: "Path-Copy-4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifiShowApn);
export default __webpack_public_path__ + "static/media/icon_wifi_showAPN.97f8a0f83a6c7de558a8b38b21375552.svg";
export { ForwardRef as ReactComponent };